import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { CaseloadReading, READING_LABEL } from '@innerhive-internal/innerhive-common';
import { READING_PILL } from './agencyChartTheme';

const useStyles = createUseStyles({
    pill: {
        display: 'inline-block',
        borderRadius: 20,
        fontWeight: 700,
        letterSpacing: '0.03em',
        textTransform: 'uppercase' as const,
        whiteSpace: 'nowrap' as const
    },
    regular: {
        padding: '3px 12px',
        fontSize: 11.5
    },
    compact: {
        padding: '2px 8px',
        fontSize: 10.5
    },
    incident: READING_PILL.incident,
    worthWatching: READING_PILL.worthWatching,
    steady: READING_PILL.steady,
    unknown: READING_PILL.unknown
});

/** A reading as a pill carrying its label, in the shades READING_PILL chose for legible text. */
export const ReadingPill: FC<{
    reading: CaseloadReading;
    dataId: string;
    /** Smaller, for a pill sitting beside a name in a list row. */
    compact?: boolean;
}> = ({ reading, dataId, compact = false }) => {
    const classes = useStyles();
    return (
        <span className={`${classes.pill} ${compact ? classes.compact : classes.regular} ${classes[reading]}`} data-id={dataId} data-reading={reading}>
            {READING_LABEL[reading]}
        </span>
    );
};
